var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreshIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3598e4c-b5d6-4327-bcd4-465cc05f1046",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.56 140.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M81.69,23.83h0a15.58,15.58,0,0,0,11.93,5h0a15.61,15.61,0,0,1,16.13,15.07q0,.52,0,1h0a15.6,15.6,0,0,0,4.94,11.94h0a15.61,15.61,0,0,1,.75,22.06q-.36.39-.75.75h0a15.57,15.57,0,0,0-4.94,11.93h0a15.62,15.62,0,0,1-15.07,16.13c-.36,0-.71,0-1.06,0h0a15.6,15.6,0,0,0-11.93,4.94h0a15.62,15.62,0,0,1-22.07.75c-.25-.24-.5-.49-.74-.75h0a15.64,15.64,0,0,0-11.94-4.94h0A15.61,15.61,0,0,1,30.82,92.64a9.37,9.37,0,0,1,0-1.06h0a15.59,15.59,0,0,0-4.95-11.93h0a15.61,15.61,0,0,1-.74-22.07c.24-.25.49-.5.74-.74h0A15.61,15.61,0,0,0,30.82,44.9h0A15.59,15.59,0,0,1,45.89,28.78a9.19,9.19,0,0,1,1,0h0a15.61,15.61,0,0,0,11.94-5h0a15.6,15.6,0,0,1,22.06-.74C81.2,23.33,81.45,23.58,81.69,23.83Z",
    style: {
      fill: "#f0dbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,41.4A5.55,5.55,0,0,0,109.35,44l-7,11.23,3.47,3.47,11.23-7a5.57,5.57,0,0,0-3-10.29Z",
    style: {
      fill: "#a97450"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06,107.31a5.57,5.57,0,1,0,5.9,9.44A5.44,5.44,0,0,0,53.73,115l7-11.23-3.47-3.47Z",
    style: {
      fill: "#a97450"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 69.7,
    width: 63.68,
    height: 19.59,
    transform: "translate(-32.33 80.94) rotate(-45)",
    style: {
      fill: "#d8ab8b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.6,
    y: 79.11,
    width: 63.68,
    height: 8.57,
    transform: "translate(-33.95 84.84) rotate(-45)",
    style: {
      fill: "#c7865c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.46,
    y: 47.51,
    width: 3.46,
    height: 23.27,
    transform: "translate(-23.9 60.59) rotate(-45)",
    style: {
      fill: "#e5cbae"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 44.08,
    width: 3.46,
    height: 17.14,
    transform: "translate(-16.14 66.34) rotate(-45)",
    style: {
      fill: "#e5cbae"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.96,
    y: 61.4,
    width: 3.46,
    height: 17.14,
    transform: "translate(-33.46 59.17) rotate(-45)",
    style: {
      fill: "#e5cbae"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 76.33,
    width: 3.46,
    height: 9.8,
    transform: "translate(-43.2 58.18) rotate(-45)",
    style: {
      fill: "#e5cbae"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.54,
    y: 41.69,
    width: 3.46,
    height: 9.8,
    transform: "translate(-8.55 72.53) rotate(-45)",
    style: {
      fill: "#e5cbae"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshIcon);
export default __webpack_public_path__ + "static/media/fresh-icon.71b171012eee20cf2342a6839f64f548.svg";
export { ForwardRef as ReactComponent };